module.exports = __webpack_public_path__ + "img/Neonatology.0b09c4e4.svg";